import { InjectionFeature } from '@/common/reward/types';
import { RouteLocationRaw } from 'vue-router';

interface RewardRouteConfig {
    routeToIndexPage: () => RouteLocationRaw;
    routeToInfoPage: (itemId?: number) => RouteLocationRaw;
}

const rewardRouteRegistry = new Map<InjectionFeature, RewardRouteConfig>();

export function registerRewardRoute(feature: InjectionFeature, config: RewardRouteConfig): void {
    rewardRouteRegistry.set(feature, config);
}

export function getRewardRouteToInfoPage(feature: InjectionFeature, itemId: number): RouteLocationRaw {
    if (!itemId) return {};

    const config = rewardRouteRegistry.get(feature);
    return config ? config.routeToInfoPage(itemId) : {};
}

export function getRewardRouteToIndexPage(feature: InjectionFeature): RouteLocationRaw {
    const config = rewardRouteRegistry.get(feature);

    return config ? config.routeToIndexPage() : {};
}
